/**
 * Theme's main js file
 * May handle main logic
 */
(function($, d, w) {

	$(w).on(w.ZP_READY, onReady);

	function onReady() {
		$('.zp-sticky-downloads').on("mouseenter", onOver);
		$('.zp-sticky-downloads > .downloads').on("mouseleave", onOut);
	}

	function onOver() {
		$(this).closest(".zp-sticky-downloads").addClass("over");
	}

	function onOut() {
		$(this).closest(".zp-sticky-downloads").removeClass("over");
	}

}(jQuery, document, window));